import {crafterConf, httpGet} from "@craftercms/classes";
import {composeUrl} from "@craftercms/utils";
import {config} from "../config.ts";

export const fetchEpisodeInfo = async (episodeId: string) => {
    const craftConf = crafterConf.getConfig();
    const serviceUrl = composeUrl(craftConf, config.episodeInfoServiceUrl);
    const params = {
        crafterSite: craftConf.site,
        id: episodeId
    }
    return httpGet(serviceUrl, params).toPromise()
        .then(data => {
            // console.info("Successful episode info fetch from CMS", data)
            return Promise.resolve(data)
        })
        .catch(error => {
            console.error("Failure fetching episode info from CMS", {episodeId, error})
            return Promise.reject(error)
        })
}

// The program page's episode list, generated per request from the program id (has_episodes →
// program-filtered, else latest). Returns the projected list directly, same shape as fetchItemList,
// so it drops straight into ItemListClass.constructInstance. Used by the program side carousel and
// the featured hero (same id ⇒ same SWR key ⇒ one deduped fetch).
export const fetchProgramItemList = async (id: string) => {
    const craftConf = crafterConf.getConfig();
    const serviceUrl = composeUrl(craftConf, config.programItemListServiceUrl);
    const params = {
        id: id,
        crafterSite: craftConf.site
    }
    return httpGet(serviceUrl, params).toPromise()
        .then(data => {
            return Promise.resolve(data)
        })
        .catch(error => {
            console.error("Failure fetching program item list from CMS", {id, error})
            return Promise.reject(error)
        })
}

// The video (episode) page's "latest videos" list, generated per request from the episode id (its
// state picks live → latest vs VOD → program-filtered). Same projected shape as fetchItemList.
export const fetchVideoItemList = async (id: string) => {
    const craftConf = crafterConf.getConfig();
    const serviceUrl = composeUrl(craftConf, config.videoItemListServiceUrl);
    const params = {
        id: id,
        crafterSite: craftConf.site
    }
    return httpGet(serviceUrl, params).toPromise()
        .then(data => {
            return Promise.resolve(data)
        })
        .catch(error => {
            console.error("Failure fetching video item list from CMS", {id, error})
            return Promise.reject(error)
        })
}

// The landing page's "latest videos" list, generated per request from the landing localId — the
// program's episodes rendered with the LANDING's own presentation (h_carrousel + full_episodes_title
// + the landing pageSize). Same projected shape as fetchItemList.
export const fetchLandingItemList = async (id: string) => {
    const craftConf = crafterConf.getConfig();
    const serviceUrl = composeUrl(craftConf, config.landingItemListServiceUrl);
    const params = {
        id: id,
        crafterSite: craftConf.site
    }
    return httpGet(serviceUrl, params).toPromise()
        .then(data => {
            return Promise.resolve(data)
        })
        .catch(error => {
            console.error("Failure fetching landing item list from CMS", {id, error})
            return Promise.reject(error)
        })
}

// Index-native single-list load: returns the projected list directly (same shape the old
// fetchContentModel(...).page[listName] returned), so it drops straight into
// ItemListClass.constructInstance. Used when a mount carries a list component localId.
export const fetchItemList = async (localId: string, removeCpacTv: boolean) => {
  const craftConf = crafterConf.getConfig();
  const serviceUrl = composeUrl(craftConf, config.itemListServiceUrl);
  const params = {
    localId: localId,
    crafterSite: craftConf.site,
    removeCpacTv: removeCpacTv ? "true" : "false"
  }
  return httpGet(serviceUrl, params)
    .toPromise()
    .then(data => {
      return Promise.resolve(data)
    })
    .catch(error => {
      console.error("Failure fetching item list from CMS", {localId, error});
      return Promise.reject(error)
    })
};